import { Injectable } from '@angular/core';
import { Observable, Observer }  from 'rxjs';
import { RemoteCallCommonService, ICallParams } from './remote-call-common.service';
import { InscripcionesService } from './inscripciones.service';

@Injectable({
  providedIn: 'root'
})
export class PasarelaPagoService {

  constructor(private _RemoteCallCommonS: RemoteCallCommonService, private _InscripcionesS:InscripcionesService) { }
  
  // Obtener los datos que se debe enviar al tpv para realziar el pago
  public getInfoTPV(importe: number): Observable<any> {
      // let def = $q.defer();
      // 
      // servInscripciones.Cookies.leer();
      // let info_pendientes = servInscripciones.CacheInscripciones.info_pendientes;
      // 
      // let params = {
      //     "class"     : config_inscripciones.info_pasarela.clase_php,
      //     "accion"    : config_inscripciones.info_pasarela.metodo_php,
      //     "inc_json"  : "inscripciones",
      //     "tipo"      : "json",
      //     "argumentos": {
      //         "n_comercio" : config_inscripciones.info_pasarela.n_comercio,
      //         "importe"    : importe,
      //         "info_pendiente": servInscripciones.CacheInscripciones.info_pendientes
      //     }
      // };
      // UtilBD.llamadaRemota(
      //     params,
      //     (resultado: TPVReturn) => {
      //         console.log(resultado.error.texto);
      //         def.resolve(resultado.datos);
      //     },
      //     () => {
      //         def.reject("Error leyendo datos de llamanda a la pasarela de pagos");
      // 
      //     },
      // );

      return new Observable( (obs: Observer<any>) => {
          let ids_data: string = localStorage.getItem('data_ids') || ''; // IS a json stringify
          ids_data = this._InscripcionesS.getCookie('data_ids') || '';

          const params: ICallParams = {
              "class"     : 'tpvRedSys',
              "accion"    : 'getDatosPagoTPVJSON',
              // "inc_json"  : "inscripciones",
              "tipo"      : "json",
              "argumentos": JSON.stringify({
                  "importe"    : importe,
                  "info_pendiente": JSON.parse(ids_data)
              })
          };
          this._RemoteCallCommonS.sendJSONPost(params).subscribe(
              (datosPagoTPV: any) => {
                  if ( datosPagoTPV.error.codigo ) {
                      obs.error(datosPagoTPV.error.texto)
                  } else {
                      obs.next(datosPagoTPV);
                  }
              },
              (error: string) => {
                  const msg = 'PasarelaPagoService::getInfoTPV => error leyendo config tpv\n ' + error;
                  console.error(msg);
                  obs.error(msg);
              },
          );
          
      });
  }
  
  // ---------------------------------------------------------------------------
  public callTPV(datosPagoTPV: any): void {
      const params = {
            Ds_SignatureVersion: datosPagoTPV.datosTPV.Ds_SignatureVersion,
            Ds_MerchantParameters: datosPagoTPV.datosTPV.Ds_MerchantParameters,
            Ds_Signature: datosPagoTPV.datosTPV.Ds_Signature,
      }
      this._RemoteCallCommonS.send2TPV(datosPagoTPV.url, params);
  } 
}
